import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.css";
import App from "./App";
import AdminDashboard from "./pages/AdminDashboard";
import Dashboard from "./pages/Dashboard";
import PricingPage from "./pages/PricingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DataCompliance from "./pages/DataCompliance";
import TermsOfUse from "./pages/TermsOfUse";

const path = window.location.pathname;

let Page = App;
if (path === "/admin") Page = AdminDashboard;
else if (path === "/dashboard") Page = Dashboard;
else if (path === "/pricing") Page = PricingPage;
else if (path === "/payment-success") Page = PaymentSuccess;
else if (path === "/privacy") Page = PrivacyPolicy;
else if (path === "/data-compliance") Page = DataCompliance;
else if (path === "/terms") Page = TermsOfUse;

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <Page />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
